import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface TopBarProps {
  title: string
  back?: string
  right?: ReactNode
}

function TopBar({ title, back, right }: TopBarProps) {
  return (
    <div className="flex items-center justify-between gap-2.5">
      <div className="flex items-center gap-2.5">
        {back && (
          <Link
            to={back}
            aria-label="Tilbage"
            className="grid h-10 w-10 place-items-center rounded-[10px] bg-text-2/10 text-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold focus-visible:outline-offset-2"
          >
            ←
          </Link>
        )}
        <h2 className="font-display text-[1.2rem] font-bold">{title}</h2>
      </div>
      {right}
    </div>
  )
}

export default TopBar
